import React, { useState, useContext, useEffect } from "react";
import OTPInputField from "../Components/OTPInputField"; // Custom OTP input field
import HoverButton from "../Components/HoverButton"; // adding hover styling button
import logo from "../assets/logo.png";
import mfabg from "../assets/mfabg.png";
import { useNavigate } from "react-router-dom"; //navigating between screens using usenavigate hook
import { verifyOTP, genOTP } from "../Services/UserLoginService"; //importing api exe fucntion
import Loader from "../Components/Loader"; //loader message
import { ToastContext } from "../utils/ToastContext"; // display toast message using context mandatory
import { useDispatch, useSelector } from "react-redux"; //sendign login info to sidebar and others screns.
import { setUserDetails } from "../utils/redux/reducer/userSlice"; //dispatch action for storing user details
import {
  resetMFATime,
  setMFAEmail,
  setShowMFA,
} from "../utils/redux/reducer/mfaSlice";
import Timer from "../Components/Timer";
import { IoChevronBackCircleOutline } from "react-icons/io5";

const MFAScreen = () => {
  const [passwordShown, setPasswordShown] = useState(false); //hide and show password
  const [otp, setOtp] = useState("");
  const [loader, setLoader] = useState(false); // show and hide to display loader
  const { showToast } = useContext(ToastContext); // context hook to display the toast meassage
  const [windowWidth, setWindowWidth] = useState(window.innerWidth); // State to manage window width
  const navigate = useNavigate(); //navigate

  const dispatch = useDispatch(); //sending data to redux

  const emailPayload = useSelector((state) => state.mfa.mfaEmail);
  useEffect(() => {
    document.title = "Enter OTP";
  }, []);

  useEffect(() => {
    const handlePageRefresh = () => {
      dispatch(setMFAEmail(null));
      dispatch(setShowMFA(false));
      dispatch(resetMFATime());
      showToast("OTP session expired", "success");
    };

    window.addEventListener("beforeunload", handlePageRefresh);

    return () => {
      window.removeEventListener("beforeunload", handlePageRefresh);
    };
  }, []);

  const time = new Date();
  time.setSeconds(time.getSeconds() + 299);

  // Effect hook to listen for window resize events
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup function to remove the event listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //function for hide and show password
  const togglePassword = () => setPasswordShown(!passwordShown);

  const handleBackToLogin = () => {
    dispatch(setMFAEmail(null));
    dispatch(setShowMFA(false));
    dispatch(resetMFATime());
    navigate("/login");
  };

  //login button function
  const handleLogin = async () => {
    setLoader(true);
    if (!otp || otp.length < 6) {
      //check fileds empty or not
      showToast("Kindly enter the OTP", "error"); //display toast msg
      setLoader(false); //dismiss loader
    } else {
      try {
        const payload = {
          email: emailPayload,
          encryptedOTP: otp,
        };

        //calling the api
        const validateOTP = await verifyOTP(payload);
        setLoader(true);
        if (validateOTP.message === "Success" && validateOTP.success === true) {
          const userData = validateOTP
          if (userData.message === "Success" && userData.success === true) {
            dispatch(setUserDetails(userData.data));
            localStorage.setItem("accessToken", userData.data.accessToken);
            localStorage.setItem("refreshToken", userData.data.refreshToken);
            //navigating to dashbopard
            setLoader(false); //dismiss loader
            showToast("Login Successfully!", "success");
            localStorage.setItem("ameyoAutoLogin", "true");
            dispatch(setMFAEmail(null));
            dispatch(setShowMFA(false));
            if (userData?.data?.UserDetails?.role === "Sales User") {
              navigate("/smartview");
            } else {
              navigate("/dashboard");
            }
          }
        } else {
          setLoader(false);
          showToast("OTP is Invalid or Expired", "error");
        }
      } catch (error) {
        setLoader(false);
        showToast("Oops Something Wrong!", "error");
      }
    }
  };

  const handleResendOTP = async () => {
    try {
      const generateOTP = await genOTP({ email: emailPayload });
      if (generateOTP.message === "Success" && generateOTP.success === true) {
        showToast("OTP has been sent", "success");
      }
    } catch (error) {
      setLoader(false);
      showToast("Error while generating OTP", "error");
      dispatch(setMFAEmail(null));
      dispatch(setShowMFA(false));
      dispatch(resetMFATime());
    }
  };

  const handleOtpChange = (value) => {
    setOtp(value);
  };

  // on form submit will check which function to call
  const handleFormSubmit = (e) => {
    e.preventDefault(); // Prevents the default form submission behavior
    handleLogin();
  };

  return (
    <div>
      {loader === true ? <Loader /> : null}
      <div
        style={{
          ...styles.container,
          flexDirection: windowWidth > 768 ? "row" : "column",
        }}
      >
        {/* displaying forms on left side of screen */}
        <div style={styles.left}>
          <img src={logo} alt="Company Logo" style={styles.logo} />
          {/* displaying forms from here */}
          <form onSubmit={handleFormSubmit} autoComplete="off">
            <>
              <p style={styles.title}>OTP Verification</p>
              <div style={styles.inputContainers}>
                <div>
                  <p style={styles.userTitle}>
                    Enter the OTP sent to your registered Email Address
                  </p>
                  <div style={{ marginTop: "50px" }}>
                    <OTPInputField
                      type={passwordShown ? "text" : "password"}
                      iconName={passwordShown ? "IoEye" : "IoEyeOff"}
                      placeholder="*"
                      // value={otp}
                      //   onChange={(e) => setPassword(e.target.value)}
                      onOtpChange={handleOtpChange}
                      onClickIcon={togglePassword}
                      autoComplete="off"
                    />
                  </div>
                </div>
                {/* going to forgot password screen */}
                {/* <div style={styles.forgotPassword}>
                  OTP will expire in 5 mins
                </div> */}
                {/* <div style={styles.resendText}>
                <span>You will be able to resend OTP after expiry</span>
                </div> */}
                <div style={styles.forgotPassword}>
                  <Timer expiryTimestamp={time} handleClick={handleResendOTP} />
                </div>
                {/* displaying login button */}
                <div style={styles.buttonContainers}>
                  <HoverButton
                    //   onClick={handleLogin}
                    text="Verify"
                    iconName="MdOutlineVerified"
                    type="submit"
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "5px",
                      cursor: "pointer",
                      color: "#EC181E",
                    }}
                    onClick={handleBackToLogin}
                  >
                    <IoChevronBackCircleOutline style={{ fontSize: "15px" }} />
                    <p style={{ fontSize: "15px" }}>Back to Login</p>
                  </div>
                </div>
              </div>
            </>
          </form>
        </div>
        {/* displaying image and welcome msg on right side of screen */}
        <div style={styles.right}>
          <img src={mfabg} alt="Background" style={styles.loginbg} />
          <p
            style={{
              color: "#06152B",
              fontSize: "20px",
              fontWeight: "bold",
              textAlign: "center",
              margin: 0,
              // padding: 10,
              width: "40%",
            }}
          >
            "Each lead is a step closer to greatness. Let your hard work today
            craft your legacy tomorrow."
          </p>
        </div>
      </div>
    </div>
  );
};

export default MFAScreen;

const styles = {
  container: {
    backgroundColor: "#FFFFFF",
    display: "flex",
    height: "100vh",
    flexWrap: "wrap",
  },
  logo: {
    maxHeight: "123px",
  },
  loginbg: {
    minHeight: "100px",
    minWidth: "10rem",
    maxWidth: "35rem",
    width: "100%",
    objectFit: "cover",
  },
  right: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "#F1F4FA",
    padding: "10px",
  },
  left: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minWidth: "425px",
    padding: "30px",
    gap: "10%",
  },
  title: {
    color: "#06152B",
    fontSize: "25px",
    fontWeight: "600",
  },
  inputContainers: {
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  buttonContainers: {
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  userTitle: {
    color: "#06152B",
    fontSize: "16px",
    fontWeight: "500",
    marginTop: "-10px",
  },
  forgotPassword: {
    textAlign: "end",
    width: "100%",
    // margin: "20px 0",
    color: "#EC181E",
    cursor: "default",
  },
  resendText: {
    textAlign: "end",
    width: "100%",
    marginTop: "5px",
    color: "#EC181E",
    cursor: "default",
  },
};
